// components
import { BackgroundImage } from 'components/background-image/background-image';
import { InnerHtml } from 'components/InnerHtml/inner-html';

// utils
import { truncateAtWordBoundary } from 'utils/truncate';

export interface LandingpageIntroProps {
  headline: string;
  subline: string;
  headlineColor: 'white' | 'black';
  headlinePosition: string;
  pictureObject: ImageObject;
  isSectionReference?: boolean;
}

export function LandingpageIntro({
  headlinePosition,
  headline,
  subline,
  headlineColor,
  pictureObject: { url, remote, uid, format, format2x, format3x },
  isSectionReference,
}: Readonly<LandingpageIntroProps>) {
  const changeTextColor =
    headlineColor === 'black'
      ? 'c-landingpage-intro__content--black'
      : 'c-landingpage-intro__content--white';

  const baseClassName = 'grid-container c-landingpage-intro__content';
  const headlinePositionClassNames = {
    'top-left': 'c-landingpage-intro__content--top-left',
    'top-right': 'c-landingpage-intro__content--top-right',
    'bottom-right': 'c-landingpage-intro__content--bottom-right',
    'bottom-left': 'c-landingpage-intro__content--bottom-left',
  };

  return (
    <BackgroundImage
      uid={uid}
      format={format}
      format2x={format2x}
      format3x={format3x}
      isRemoteMedia={remote}
      className="c-landingpage-intro"
      imagePath={url}
    >
      <div className={`${baseClassName} ${headlinePositionClassNames[headlinePosition] || ''}`}>
        <div className={`${changeTextColor}`}>
          {headline && (
            <InnerHtml
              as="h1"
              content={truncateAtWordBoundary(headline, 30)}
              previewId="#st_titleLandingpage"
              isSectionReference={isSectionReference}
            />
          )}
          {subline && (
            <InnerHtml
              as="h2"
              content={truncateAtWordBoundary(subline, 60)}
              previewId="#st_subtitleLandingpage"
              isSectionReference={isSectionReference}
            />
          )}
        </div>
      </div>
    </BackgroundImage>
  );
}
